var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}},[_c('path',{attrs:{"stroke":"#475467","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.333","d":"M8 12.667V3.333m0 0L12.667 8M8 3.333 3.333 8"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }